import weaponCombat from '../../../data/weapon-combat.json';
export function basicWeaponRange(kind:string):number{return (weaponCombat as Record<string,{range:number}>)[kind]?.range??165;}
export type WeaponVisualProfile={
  mode:'blade'|'pole'|'bow'|'crossbow'|'talisman';
  length:number;
  width:number;
  tint:number;
};
export type OutfitVisualProfile={
  torsoWidth:number;
  torsoHeight:number;
  pelvisWidth:number;
  tint:number;
  accent:number;
  eyeShadow:boolean;
  leanScale:number;
};

export function weaponVisualProfile(kind:string):WeaponVisualProfile {
  switch(kind){
    case 'knife':return {mode:'blade',length:18,width:4,tint:0xd8d0bb};
    case 'sword':return {mode:'blade',length:36,width:5,tint:0xe5dcc5};
    case 'spear':return {mode:'pole',length:74,width:3,tint:0xb99762};
    case 'staff':return {mode:'pole',length:66,width:5,tint:0x74513a};
    case 'bow':return {mode:'bow',length:48,width:3,tint:0xa77745};
    case 'crossbow':return {mode:'crossbow',length:34,width:4,tint:0x8c6743};
    case 'talisman':return {mode:'talisman',length:22,width:14,tint:0xe5c35b};
    default:return {mode:'blade',length:30,width:4,tint:0xd8d0bb};
  }
}

export function outfitVisualProfile(kindOrId:string,preset:string):OutfitVisualProfile {
  const lean=preset==='phu-bao-thai-ban';
  const palette:Record<string,[number,number]>={
    villager:[0x445a6c,0xb98b58],indigo:[0x3f566e,0xb98b58],linen:[0xa69072,0x744a32],
    hunter:[0x55654b,0x987344],forest:[0x4e6348,0xb39155],crimson:[0x7d403c,0xd1a05f],'hunter-vest':[0x536347,0xa78352],
    sword:[0x754d3f,0xd3b178],'sword-armor':[0x744738,0xd0aa6d],
    spear:[0x4e5f53,0xc4a56b],'spear-armor':[0x4a5d51,0xbca16f],
    shaman:[0x493c5b,0xd0ad58],'shaman-robe':[0x493958,0xd6b65c],
  };
  const [tint,accent]=palette[kindOrId]??palette.villager!;
  return {
    torsoWidth:lean?25:29,
    torsoHeight:lean?36:35,
    pelvisWidth:lean?25:29,
    tint,accent,
    eyeShadow:lean,
    leanScale:lean?.92:1,
  };
}

/** Shared sprite geometry for the world rig and the equipment preview. */
export function weaponAttachmentProfile(kind:string):{width:number;height:number;originX:number;originY:number;angle:number}{
 const weapon=weaponVisualProfile(kind);
 // Authored source grips: blades point upward with handles at the bottom;
 // staff is a short ceremonial wand, bows grip the middle, crossbows the stock.
 const grip:Record<string,[number,number,number]>={knife:[.5,.9,152],sword:[.5,.9,152],spear:[.5,.9,-8],staff:[.23,.45,-8],bow:[.5,.5,-28],crossbow:[.78,.65,90],talisman:[.5,.06,-28]};
 const [originX,originY,angle]=grip[kind]??grip.sword!;
 return {width:weapon.mode==='bow'?25:weapon.mode==='crossbow'?34:weapon.mode==='talisman'?14:Math.max(7,weapon.width*2),height:kind==='staff'?46:weapon.mode==='crossbow'?20:weapon.length,originX,originY,angle};
}

/** Isolate the authored weapon from neighboring atlas fragments in both renderers. */
export function weaponAttachmentAsset(kind:string):string {
 return `/assets/characters/r15/equipment/${kind}${kind==='staff'||kind==='crossbow'?'-attachment-v002.svg':'.webp'}`;
}
